import * as Y from 'yjs'
import { yCustomNodeDatas, ydoc } from '@/shared/config/yjs-config.ts'
import { YJS_TASK_LIFECYCLE_ORIGIN } from '@/shared/lib/yjs/transaction-origin'
import { clearListTask } from './task-info-store'
export type { GlobalTaskInfo } from './task-info-store'

export type NodeStatus = 'pending' | 'running' | 'completed' | 'failed' | 'canceled' | ''

export function hasGeneratingNodes(): boolean {
  let generating = false
  yCustomNodeDatas.forEach((yNode) => {
    if (generating) return
    const status = yNode.get('status')
    if (status === 'pending' || status === 'running') {
      generating = true
    }
  })
  return generating
}

export function isNodeGenerating(nodeId: string): boolean {
  const yNodeData = yCustomNodeDatas.get(nodeId) as Y.Map<unknown> | undefined
  if (!yNodeData) return false
  const status = yNodeData.get('status')
  return status === 'pending' || status === 'running'
}

export function setTaskStatus(nodeId: string, status: NodeStatus) {
const yNodeData = yCustomNodeDatas.get(nodeId) as Y.Map<unknown> | undefined
  if (!yNodeData) return
  ydoc.transact(() => {
    yNodeData.set('status', status)
  }, YJS_TASK_LIFECYCLE_ORIGIN)
}

export function cancelTask(nodeId: string) {
  const yNodeData = yCustomNodeDatas.get(nodeId) as Y.Map<unknown> | undefined
  if (!yNodeData) return
  const runId = yNodeData.get('runId')
  if (!runId) return
  ydoc.transact(() => {
    clearListTask(nodeId);
  }, YJS_TASK_LIFECYCLE_ORIGIN)
}

export function againTask(nodeId: string) {
  const yNodeData = yCustomNodeDatas.get(nodeId) as Y.Map<unknown> | undefined
  if (!yNodeData) return
  ydoc.transact(() => {
    yNodeData.set('status', 'pending')
    yNodeData.set('taskId', '')
    yNodeData.set('progress', 0)
  }, YJS_TASK_LIFECYCLE_ORIGIN)
}

export function restartTask(nodeId: string, runId: string) {
  const yNodeData = yCustomNodeDatas.get(nodeId) as Y.Map<unknown> | undefined
  if (!yNodeData) return
  ydoc.transact(() => {
    yNodeData.set('runId', runId)
    yNodeData.set('status', 'pending')
    yNodeData.set('progress', 0)
    yNodeData.set('taskId', '')
  }, YJS_TASK_LIFECYCLE_ORIGIN)
}
